module.exports = __webpack_public_path__ + "img/shield-pending.bee0fd81.svg";